export const groupKeyForCurso = (curso) => {
    if (!curso)
        return "";
    const existing = String(curso.key || "").trim();
    if (existing)
        return existing;
    const code = String(curso.course_code || curso.course_id || "").trim();
    return `COURSE#${curso.school_id || ""}#${curso.year || ""}#${code}`;
};
